<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>设备</el-breadcrumb-item>
      <el-breadcrumb-item>保养规则管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="规则名称">
            <el-input
              v-model="filter.name"
              placeholder="名称"
              @keyup.enter.native="requestSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header" v-permission="Auth.maintainanceRuleManage">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleEdit"
          >新增保养规则</el-button
        >
      </div>

      <el-table :data="list" v-loading="loading" stripe style="width: 100%">
        <el-table-column label="规则名称" prop="name"> </el-table-column>
        <el-table-column
          label="设备分类"
          prop="item_category.whole_name"
          min-width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.item_category.whole_name.replace(/,/g, ' - ') }}
          </template>
        </el-table-column>
        <el-table-column label="设备号" prop="equipment_number" min-width="90">
          <template slot-scope="scope">
            <div
              class="mb-5"
              v-for="item in scope.row.equipment_number.split('、')"
              :key="item"
            >
              <el-tag size="mini" type="info">
                {{ item }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="应用" prop="application">
          <template slot-scope="scope">
            {{ scope.row.application ? scope.row.application.join(' / ') : '' }}
          </template>
        </el-table-column>
        <el-table-column label="工艺" prop="craft"> </el-table-column>
        <el-table-column label="保养周期">
          <template slot-scope="scope">
            每{{ scope.row.period }}月一次
          </template>
        </el-table-column>
        <el-table-column label="保养套餐">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; gap: 5px">
              <el-tag
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
                size="mini"
                v-for="item in scope.row.commodity_combo"
                :key="item.id"
                ><span
                  style="
                    max-width: 80%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  >{{ item.part_number }}</span
                >
                x {{ item.number }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 2 ? 'success' : 'gray'"
              :name="scope.row.status == 2 ? '启用' : '禁用'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.maintainanceRuleManage"
              :title="`确认${scope.row.status == 2 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 2 ? 'danger' : 'primary'"
                plain
                class="mr-5"
                size="mini"
                >{{ scope.row.status == 2 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.maintainanceRuleManage"
              title="确认删除吗？"
              v-if="scope.row.status == 1"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              v-permission="Auth.maintainanceRuleManage"
              class="ml-5"
              type="primary"
              plain
              size="mini"
              v-if="scope.row.status == 1"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <ModelFormer
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></ModelFormer>
  </div>
</template>

<script>
import {
  maintainanceRuleList,
  deleteMaintainanceRule,
  updateMaintainanceRuletatus,
} from '@/service/getData'
import ModelFormer from './former'

export default {
  components: {
    ModelFormer,
  },
  data() {
    return {
      loading: false,
      model: {},
      itemFormerVisible: false,
      editIndex: 0,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        name: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await maintainanceRuleList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.name = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.getData()
    },
    updatedCallback(data) {
      this.getData()
    },
    handleEdit(index, item) {
      if (item) {
        this.editIndex = index
        this.model = this.clone(item)
      } else {
        this.model = {
          name: '',
          eqequipment_number: '',
          application: [],
          craft: '',
          period: '',
          commodity_ids: [],
          commodity_combo: [],
        }
      }
      this.itemFormerVisible = true
    },
    async handleDelete(index, id) {
      let res = await deleteMaintainanceRule(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    async handleSwitchStatus(index, id) {
      let res = await updateMaintainanceRuletatus(id)
      if (res.code == 0) {
        this.getData()
      }
    },
  },
}
</script>
